import { authenticatedMiddleware } from '../../permissions/middlewares/authenticatedMiddleware.js';
import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { updateSalaryFromGptResolver } from '../server/updateSalaryFromGptResolver.js';

export const updateSalaryFromGpt = registerMutation({
  type: () => Boolean,
  operationName: 'updateSalaryFromGpt',
  middlewares: [authenticatedMiddleware],
  params: [{ type: () => String, name: 'clipboardContent' }],
  resolve: updateSalaryFromGptResolver,
});
